module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#filter",
      toString: function () {
        return this.url;
      }
    }